module.exports = __webpack_public_path__ + "img/lb_zww.22d54380.svg";